import React from 'react';
import { BasePage } from '@sm/webassets';
import { useLocation } from 'react-router-dom';
import SEO from '~pricing/components/SEO';
import useScript from '~pricing/hooks/useScripts';
import { EXTERNAL_SCRIPTS } from '~pricing/lib/constants';
import useMainStyles from './useStyles';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';

export default function Layout({ children }: { children: React.ReactNode }): JSX.Element {
  const { priceExperiment } = usePricingExperiments();

  const isPnPRefresh =
    priceExperiment.hasAssignment && priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment;

  useScript(EXTERNAL_SCRIPTS);
  // GP-69 Needs full page width so having the 1400px max-width from Main breaks the ui
  const routerLocation = useLocation();
  const { Main, RefreshFullWidth } = useMainStyles();

  return (
    <BasePage pageId="Pricing" legacyWeb="billweb" sticky={false}>
      <SEO>
        <main
          className={`${routerLocation.pathname !== '/pricing' ? Main : ''} ${isPnPRefresh ? RefreshFullWidth : ''}`}
        >
          {children}
        </main>
      </SEO>
    </BasePage>
  );
}
